'use client';
import { Box, Stack } from '@mui/material';
import { MarketingPageComponentProps } from '@services/launches/fetchLaunchMarketingContent';
import CommonContainer from '@components/CommonContainer';
import {
  DesktopBreakpoint,
  MobileBreakpoint,
  TabletBreakpoint,
} from '@components/Breakpoints';

import DynamicHideBlock from '@components/DynamicHideBlock';
import CustomVideo from '@components/CustomVideo';
import AlGhadeerTitle from '../AlGhadeerTitle';
import AlGhadeerParagraph from '../AlGhadeerParagraph';
import cn from './style.module.scss';
export default function AlGhadeerHorizon(props: MarketingPageComponentProps) {
  const horizonSection = props?.locale?.section?.find(
    (section: any) => section.type === 'horizon' && section.enabled
  );
  if (!horizonSection) return null;

  return (
    <Stack
      component="section"
      className={cn.alGhadeerHorizonWrapper}
      id="alGhadeerHorizon"
    >
      <Box className={cn.alGhadeerHorizonInner}>
        <Box className={cn.alGhadeerHorizonBlock}>
          <Box className={cn.alGhadeerHorizonContent}>
            <CommonContainer
              maxWidth={{ xs: '100%', md: '100%', lg: '100%' }}
              flexGrow={1}
              paddingInline={{ xs: '1.25rem', md: '5%', lg: '10%' }}
            >
              <Box className={cn.horizonContentElement}>
                <Box className={cn.alGhadeerHorizonHeading}>
                  <AlGhadeerTitle
                    titleData={horizonSection?.alghadeerHorizonHeading}
                  />
                </Box>
                <Box className={cn.alGhadeerHorizonText}>
                  <AlGhadeerParagraph
                    paragraphData={horizonSection?.alghadeerHorizonContent}
                  />
                </Box>
              </Box>
            </CommonContainer>
          </Box>
          <DynamicHideBlock data={horizonSection?.alghadeerHorizonStoryFilm}>
            <Box className={cn.alGhadeerHorizonBanner}>
              <MobileBreakpoint>
                <CustomVideo
                  src={horizonSection?.alghadeerHorizonStoryFilm?.mobileUrl}
                  poster={
                    horizonSection?.alghadeerHorizonStoryFilm?.mobilePoster
                  }
                />
              </MobileBreakpoint>
              <TabletBreakpoint>
                <CustomVideo
                  src={horizonSection?.alghadeerHorizonStoryFilm?.tabletUrl}
                  poster={
                    horizonSection?.alghadeerHorizonStoryFilm?.tabletPoster
                  }
                />
              </TabletBreakpoint>
              <DesktopBreakpoint>
                <CustomVideo
                  src={horizonSection?.alghadeerHorizonStoryFilm?.desktopUrl}
                  poster={
                    horizonSection?.alghadeerHorizonStoryFilm?.desktopPoster
                  }
                />
              </DesktopBreakpoint>
            </Box>
          </DynamicHideBlock>
        </Box>
      </Box>
    </Stack>
  );
}
